import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { PDFDocument, rgb, degrees } from 'pdf-lib';

import { ErroNotificacaoService } from 'src/app/erro-notificacao.service';
import { AuthService } from 'src/app/seguranca/auth.service';
import { DocumentacaoGeralFiltro, FinanceiroService } from '../financeiro.service';
import { LogVisualizarDocumentoPrestacaoConta } from 'src/app/model/LogVisualizarDocumentoPrestacaoConta';

@Component({
  selector: 'app-prestacao-conta',
  templateUrl: './prestacao-conta.component.html',
  styleUrls: ['./prestacao-conta.component.css']
})
export class PrestacaoContaComponent implements OnInit {

  token!: string;
  payLoad: any;

  idSocio = 0;

  renovarLoginDialog = false;
  aguardeDialog = false;

  documentacaoGeralFiltro = new DocumentacaoGeralFiltro();
  documentacoesPage: any[] = [];
  totalRegistroDocumentacao = 0;

  constructor(
    private jwtDecoder: JwtHelperService,
    private auth: AuthService,
    private toasty: ToastrService,
    private rotaNavegar: Router,
    private erroHandle: ErroNotificacaoService,
    private financeiroService: FinanceiroService,
    private rota: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (!this.validarNavegador()) {
      this.toasty.error(
        'Este documento só pode ser visualizado no Google Chrome.',
        'NAVEGADOR NÃO SUPORTADO'
      );

      return;
    }

    this.inicializarUsuario();
    this.idSocio = Number(this.rota.snapshot.params.idSocio);
    window.scrollTo(0, 0);
  }

  private validarNavegador(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChrome = userAgent.includes('chrome') && !userAgent.includes('edg') && !userAgent.includes('firefox');
    return isChrome;
  }

  private inicializarUsuario(): void {
    this.token = localStorage.getItem('access_token_xmanager') || '';
    this.payLoad = this.jwtDecoder.decodeToken(this.token);
  }

  getDocumentacaoGeralByIdPDF(id: number): void {
    if (this.auth.isAccessTokenInvalido()) {
      this.renovarLoginDialog = true;
      return;
    }

    this.aguardeDialog = true;
    this.limparVisualizador();
    this.financeiroService.getDocumentacaoGeralById(id, this.idSocio, this.token).subscribe({
      next: async (documento: any) => {
        await this.gerarVisualizadorPDF(documento.arquivo);
        this.registrarLogVisualizacao(id);
        this.aguardeDialog = false;
      },

      error: (erro) => {
        this.aguardeDialog = false;
        this.erroHandle.handle(erro);
      }
    });
  }

  private limparVisualizador(): void {
    const container = document.getElementById('pdfContainer');
    if (container) {
      container.innerHTML = '';
    }
  }

  async gerarVisualizadorPDF(base64PDF: string): Promise<void> {
    try {
      const byteArray = Uint8Array.from(atob(base64PDF), c => c.charCodeAt(0));
      const pdfDoc = await PDFDocument.load(byteArray);
      const pages = pdfDoc.getPages();
      this.adicionarMarcaDagua(pages);
      const modifiedPdfBytes = await pdfDoc.save();
      const modifiedBase64 = await this.convertArrayBufferToBase64(modifiedPdfBytes);
      this.renderizarPDF(modifiedBase64);

    } catch (error) {
      console.error(
        'Erro ao gerar visualizador PDF:',
        error
      );
      this.toasty.error(
        'Erro ao abrir documento.',
        'ATENÇÃO'
      );
    }
  }

  private adicionarMarcaDagua(pages: any[]): void {
    const marcaDagua =
      `Visualizado por: ${this.payLoad.nome}
      CPF: ${this.payLoad.user_name}   
      ID-Associado: ${this.payLoad.id}
      Data/Hora: ${new Date().toLocaleString()}`;

    pages.forEach((page) => {
      const { width, height } = page.getSize();
      for (let y = 80; y < height; y += 180) {
        for (let x = -120; x < width; x += 280) {
          page.drawText(marcaDagua, {

            x,
            y,

            size: 12,
            rotate: degrees(-35),
            opacity: 0.30,
            lineHeight: 18,
            color: rgb(0.30, 0.30, 0.30)
          });
        }
      }
    });
  }

  private renderizarPDF(base64: string): void {
    const container = document.getElementById('pdfContainer');
    if (!container) {
      return;
    }
    container.innerHTML = '';
    const iframe = document.createElement('iframe');
    iframe.src = `data:application/pdf;base64,${base64}` + '#toolbar=0&navpanes=0&scrollbar=0';
    iframe.style.width = '100%';
    iframe.style.height = '800px';
    iframe.style.border = 'none';

    /*
    iframe.setAttribute(
      'sandbox',
      'allow-scripts'
    );
    */

    container.appendChild(iframe);
    this.bloquearAcoesVisualizador(container);
  }

  private bloquearAcoesVisualizador(container: HTMLElement): void {
    container.addEventListener('contextmenu',
      (event) => {
        event.preventDefault();
      }
    );

    container.addEventListener('keydown',
      (event: KeyboardEvent) => {
        const tecla =
          event.key.toLowerCase();
        const bloqueado =
          (event.ctrlKey && tecla === 's') ||
          (event.ctrlKey && tecla === 'p');

        if (bloqueado) {
          event.preventDefault();
        }
      }
    );
  }

  private registrarLogVisualizacao(idDocumento: number): void {
    this.aguardeDialog = true;
    let logVisualizar = new LogVisualizarDocumentoPrestacaoConta();
    logVisualizar.idDocumento = idDocumento;
    logVisualizar.idSocio = this.payLoad.id;
    logVisualizar.cpfAssociado = this.payLoad.user_name;
    logVisualizar.nomeAssociado = this.payLoad.nome;
    logVisualizar.dataHora = new Date();
    this.financeiroService.salvarLogVisualizacao(logVisualizar, this.token).subscribe({
      next: (dados) => { 
        this.aguardeDialog = false;
        this.toasty.success('Log de visualização salvo com sucesso: ' + dados.id, 'ATENÇÃO!');
      }
    });

    const log = {
      idDocumento,
      idAssociado: this.payLoad.id,
      nomeAssociado: this.payLoad.nome,
      dataHora: new Date(),
      tipoEvento: 'VISUALIZOU_DOCUMENTO'
    };

    console.log(
      'LOG VISUALIZAÇÃO:',
      log
    );

    /*
    this.financeiroService
      .salvarLogVisualizacao(log)
      .subscribe();
    */
  }

  async convertArrayBufferToBase64(
    buffer: ArrayBuffer
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(new Blob([buffer]));
      reader.onloadend = () => {const base64String = reader.result as string;
        resolve(
          base64String.split(',')[1]
        );
      };

      reader.onerror = error => reject(error);
    });
  }

  popularDocumentacaoPage(pagina = 0): void {
    if (this.auth.isAccessTokenInvalido()) {
      this.renovarLoginDialog = true;
      return;
    }

    this.aguardeDialog = true;
    this.documentacaoGeralFiltro.pagina = pagina;
    this.documentacaoGeralFiltro.idSetorDocumentacao = 1;
    this.financeiroService
      .documentacaoGeralPage(
        this.documentacaoGeralFiltro,
        this.token
      )
      .subscribe({
        next: (dados: any) => {
          this.documentacoesPage = dados.content;
          this.totalRegistroDocumentacao = dados.totalElements;
          this.aguardeDialog = false;
        },

        error: (erro) => {
          this.aguardeDialog = false;
          this.erroHandle.handle(erro);
        }
      });
  }

  mudarPaginaDocumentacao(event: any): void {
    const pagina = event.first / event.rows;
    this.popularDocumentacaoPage(pagina);
  }

  pesquisarDocumento(event: any): void {
    const descricao = event.target.value;
    const numero = descricao.length;
    const numeroModelo = numero % 2;

    this.documentacaoGeralFiltro.descricao = this.documentacaoGeralFiltro.descricao.toUpperCase();

    if (numeroModelo === 0) {
      this.documentacaoGeralFiltro.pagina = 0;
      this.financeiroService.documentacaoGeralPage(this.documentacaoGeralFiltro, this.token).subscribe({
        next: (dados: any) => {
          this.documentacoesPage = dados.content;
          this.totalRegistroDocumentacao = dados.totalElements;
        },
        error: (erro) => {
          this.erroHandle.handle(erro);
        }
      });
    }
  }

  login(usuario: string, senha: string): void {
    this.aguardeDialog = true;
    this.auth
      .renovarLogin(usuario, senha)
      .subscribe({
        next: (dados: any) => {
          this.token = dados.access_token;
          this.auth.armazenarToken(dados.access_token);
          this.payLoad = this.jwtDecoder.decodeToken(this.token);
          this.aguardeDialog = false;
          this.renovarLoginDialog = false;
        },

        error: (erro) => {
          this.aguardeDialog = false;
          if (
            erro.status === 400 &&
            erro.error.error === 'invalid_grant'
          ) {
            this.toasty.error(
              'USUÁRIO OU SENHA INVÁLIDO!',
              'ATENÇÃO!'
            );
            this.rotaNavegar.navigate(['']);
            return;
          }
          this.erroHandle.handle(erro);
          this.rotaNavegar.navigate(['']);
        }
      });
  }
}